// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               unknown
// source: photon/imessage/v1/chat_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import type { CallContext, CallOptions } from "nice-grpc-common";
import { Empty } from "../../../google/protobuf/empty.js";
import { ChatServiceType, chatServiceTypeFromJSON, chatServiceTypeToJSON } from "./address_types.js";
import { Chat, ChatChangeEvent } from "./chat_types.js";
import { Message } from "./message_types.js";
import { Heartbeat } from "./streaming.js";

export const protobufPackage = "photon.imessage.v1";

export interface CreateChatRequest {
  addresses: string[];
  service: ChatServiceType;
  initialMessage?: CreateChatInitialMessage | undefined;
  clientMessageId?: string | undefined;
}

export interface CreateChatInitialMessage {
  text: string;
  attributedBody?: Uint8Array | undefined;
  effectId?: string | undefined;
  subject?: string | undefined;
}

export interface CreateChatResponse {
  chat: Chat | undefined;
  initialMessage?: Message | undefined;
}

export interface MarkChatReadRequest {
  chatGuid: string;
}

export interface SetBackgroundRequest {
  chatGuid: string;
  data: Uint8Array;
}

export interface RemoveBackgroundRequest {
  chatGuid: string;
}

export interface ShareContactInfoRequest {
  chatGuid: string;
}

export interface SetTypingRequest {
  chatGuid: string;
  isTyping: boolean;
}

export interface GetChatRequest {
  chatGuid: string;
}

export interface GetChatResponse {
  chat: Chat | undefined;
}

export interface GetChatCountRequest {
  includeArchived: boolean;
}

export interface GetChatCountResponse {
  count: number;
}

export interface HasBackgroundRequest {
  chatGuid: string;
}

export interface HasBackgroundResponse {
  backgroundPresent: boolean;
}

export interface SubscribeChatEventsRequest {
  /** Absent = subscribe to every chat the caller can observe. */
  chatGuid?: string | undefined;
}

export interface SubscribeChatEventsResponse {
  /**
   * Monotonic global sequence shared with `EventService.CatchUpEvents`
   * and every other `Subscribe*` stream. Absent on heartbeat frames.
   */
  sequence?: number | undefined;
  chatChanged?: ChatChangeEvent | undefined;
  heartbeat?: Heartbeat | undefined;
}

function createBaseCreateChatRequest(): CreateChatRequest {
  return { addresses: [], service: 0, initialMessage: undefined, clientMessageId: undefined };
}

export const CreateChatRequest: MessageFns<CreateChatRequest> = {
  encode(message: CreateChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.addresses) {
      writer.uint32(10).string(v!);
    }
    if (message.service !== 0) {
      writer.uint32(16).int32(message.service);
    }
    if (message.initialMessage !== undefined) {
      CreateChatInitialMessage.encode(message.initialMessage, writer.uint32(26).fork()).join();
    }
    if (message.clientMessageId !== undefined) {
      writer.uint32(802).string(message.clientMessageId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.addresses.push(reader.string());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.service = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.initialMessage = CreateChatInitialMessage.decode(reader, reader.uint32());
          continue;
        }
        case 100: {
          if (tag !== 802) {
            break;
          }

          message.clientMessageId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateChatRequest {
    return {
      addresses: globalThis.Array.isArray(object?.addresses)
        ? object.addresses.map((e: any) => globalThis.String(e))
        : [],
      service: isSet(object.service) ? chatServiceTypeFromJSON(object.service) : 0,
      initialMessage: isSet(object.initialMessage)
        ? CreateChatInitialMessage.fromJSON(object.initialMessage)
        : isSet(object.initial_message)
        ? CreateChatInitialMessage.fromJSON(object.initial_message)
        : undefined,
      clientMessageId: isSet(object.clientMessageId)
        ? globalThis.String(object.clientMessageId)
        : isSet(object.client_message_id)
        ? globalThis.String(object.client_message_id)
        : undefined,
    };
  },

  toJSON(message: CreateChatRequest): unknown {
    const obj: any = {};
    if (message.addresses?.length) {
      obj.addresses = message.addresses;
    }
    if (message.service !== 0) {
      obj.service = chatServiceTypeToJSON(message.service);
    }
    if (message.initialMessage !== undefined) {
      obj.initialMessage = CreateChatInitialMessage.toJSON(message.initialMessage);
    }
    if (message.clientMessageId !== undefined) {
      obj.clientMessageId = message.clientMessageId;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateChatRequest>): CreateChatRequest {
    return CreateChatRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateChatRequest>): CreateChatRequest {
    const message = createBaseCreateChatRequest();
    message.addresses = object.addresses?.map((e) => e) || [];
    message.service = object.service ?? 0;
    message.initialMessage = (object.initialMessage !== undefined && object.initialMessage !== null)
      ? CreateChatInitialMessage.fromPartial(object.initialMessage)
      : undefined;
    message.clientMessageId = object.clientMessageId ?? undefined;
    return message;
  },
};

function createBaseCreateChatInitialMessage(): CreateChatInitialMessage {
  return { text: "", attributedBody: undefined, effectId: undefined, subject: undefined };
}

export const CreateChatInitialMessage: MessageFns<CreateChatInitialMessage> = {
  encode(message: CreateChatInitialMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.attributedBody !== undefined) {
      writer.uint32(18).bytes(message.attributedBody);
    }
    if (message.effectId !== undefined) {
      writer.uint32(26).string(message.effectId);
    }
    if (message.subject !== undefined) {
      writer.uint32(34).string(message.subject);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateChatInitialMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateChatInitialMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.attributedBody = reader.bytes();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.effectId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.subject = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateChatInitialMessage {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      attributedBody: isSet(object.attributedBody)
        ? bytesFromBase64(object.attributedBody)
        : isSet(object.attributed_body)
        ? bytesFromBase64(object.attributed_body)
        : undefined,
      effectId: isSet(object.effectId)
        ? globalThis.String(object.effectId)
        : isSet(object.effect_id)
        ? globalThis.String(object.effect_id)
        : undefined,
      subject: isSet(object.subject) ? globalThis.String(object.subject) : undefined,
    };
  },

  toJSON(message: CreateChatInitialMessage): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.attributedBody !== undefined) {
      obj.attributedBody = base64FromBytes(message.attributedBody);
    }
    if (message.effectId !== undefined) {
      obj.effectId = message.effectId;
    }
    if (message.subject !== undefined) {
      obj.subject = message.subject;
    }
    return obj;
  },

  create(base?: DeepPartial<CreateChatInitialMessage>): CreateChatInitialMessage {
    return CreateChatInitialMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateChatInitialMessage>): CreateChatInitialMessage {
    const message = createBaseCreateChatInitialMessage();
    message.text = object.text ?? "";
    message.attributedBody = object.attributedBody ?? undefined;
    message.effectId = object.effectId ?? undefined;
    message.subject = object.subject ?? undefined;
    return message;
  },
};

function createBaseCreateChatResponse(): CreateChatResponse {
  return { chat: undefined, initialMessage: undefined };
}

export const CreateChatResponse: MessageFns<CreateChatResponse> = {
  encode(message: CreateChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      Chat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    if (message.initialMessage !== undefined) {
      Message.encode(message.initialMessage, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreateChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = Chat.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.initialMessage = Message.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreateChatResponse {
    return {
      chat: isSet(object.chat) ? Chat.fromJSON(object.chat) : undefined,
      initialMessage: isSet(object.initialMessage)
        ? Message.fromJSON(object.initialMessage)
        : isSet(object.initial_message)
        ? Message.fromJSON(object.initial_message)
        : undefined,
    };
  },

  toJSON(message: CreateChatResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = Chat.toJSON(message.chat);
    }
    if (message.initialMessage !== undefined) {
      obj.initialMessage = Message.toJSON(message.initialMessage);
    }
    return obj;
  },

  create(base?: DeepPartial<CreateChatResponse>): CreateChatResponse {
    return CreateChatResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateChatResponse>): CreateChatResponse {
    const message = createBaseCreateChatResponse();
    message.chat = (object.chat !== undefined && object.chat !== null) ? Chat.fromPartial(object.chat) : undefined;
    message.initialMessage = (object.initialMessage !== undefined && object.initialMessage !== null)
      ? Message.fromPartial(object.initialMessage)
      : undefined;
    return message;
  },
};

function createBaseMarkChatReadRequest(): MarkChatReadRequest {
  return { chatGuid: "" };
}

export const MarkChatReadRequest: MessageFns<MarkChatReadRequest> = {
  encode(message: MarkChatReadRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MarkChatReadRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMarkChatReadRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MarkChatReadRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
    };
  },

  toJSON(message: MarkChatReadRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<MarkChatReadRequest>): MarkChatReadRequest {
    return MarkChatReadRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<MarkChatReadRequest>): MarkChatReadRequest {
    const message = createBaseMarkChatReadRequest();
    message.chatGuid = object.chatGuid ?? "";
    return message;
  },
};

function createBaseSetBackgroundRequest(): SetBackgroundRequest {
  return { chatGuid: "", data: new Uint8Array(0) };
}

export const SetBackgroundRequest: MessageFns<SetBackgroundRequest> = {
  encode(message: SetBackgroundRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.data.length !== 0) {
      writer.uint32(18).bytes(message.data);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetBackgroundRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetBackgroundRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = reader.bytes();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetBackgroundRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      data: isSet(object.data) ? bytesFromBase64(object.data) : new Uint8Array(0),
    };
  },

  toJSON(message: SetBackgroundRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.data.length !== 0) {
      obj.data = base64FromBytes(message.data);
    }
    return obj;
  },

  create(base?: DeepPartial<SetBackgroundRequest>): SetBackgroundRequest {
    return SetBackgroundRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetBackgroundRequest>): SetBackgroundRequest {
    const message = createBaseSetBackgroundRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.data = object.data ?? new Uint8Array(0);
    return message;
  },
};

function createBaseRemoveBackgroundRequest(): RemoveBackgroundRequest {
  return { chatGuid: "" };
}

export const RemoveBackgroundRequest: MessageFns<RemoveBackgroundRequest> = {
  encode(message: RemoveBackgroundRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RemoveBackgroundRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRemoveBackgroundRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RemoveBackgroundRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
    };
  },

  toJSON(message: RemoveBackgroundRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<RemoveBackgroundRequest>): RemoveBackgroundRequest {
    return RemoveBackgroundRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RemoveBackgroundRequest>): RemoveBackgroundRequest {
    const message = createBaseRemoveBackgroundRequest();
    message.chatGuid = object.chatGuid ?? "";
    return message;
  },
};

function createBaseShareContactInfoRequest(): ShareContactInfoRequest {
  return { chatGuid: "" };
}

export const ShareContactInfoRequest: MessageFns<ShareContactInfoRequest> = {
  encode(message: ShareContactInfoRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ShareContactInfoRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseShareContactInfoRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ShareContactInfoRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
    };
  },

  toJSON(message: ShareContactInfoRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<ShareContactInfoRequest>): ShareContactInfoRequest {
    return ShareContactInfoRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ShareContactInfoRequest>): ShareContactInfoRequest {
    const message = createBaseShareContactInfoRequest();
    message.chatGuid = object.chatGuid ?? "";
    return message;
  },
};

function createBaseSetTypingRequest(): SetTypingRequest {
  return { chatGuid: "", isTyping: false };
}

export const SetTypingRequest: MessageFns<SetTypingRequest> = {
  encode(message: SetTypingRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    if (message.isTyping !== false) {
      writer.uint32(16).bool(message.isTyping);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetTypingRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetTypingRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isTyping = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetTypingRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
      isTyping: isSet(object.isTyping)
        ? globalThis.Boolean(object.isTyping)
        : isSet(object.is_typing)
        ? globalThis.Boolean(object.is_typing)
        : false,
    };
  },

  toJSON(message: SetTypingRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    if (message.isTyping !== false) {
      obj.isTyping = message.isTyping;
    }
    return obj;
  },

  create(base?: DeepPartial<SetTypingRequest>): SetTypingRequest {
    return SetTypingRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SetTypingRequest>): SetTypingRequest {
    const message = createBaseSetTypingRequest();
    message.chatGuid = object.chatGuid ?? "";
    message.isTyping = object.isTyping ?? false;
    return message;
  },
};

function createBaseGetChatRequest(): GetChatRequest {
  return { chatGuid: "" };
}

export const GetChatRequest: MessageFns<GetChatRequest> = {
  encode(message: GetChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetChatRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
    };
  },

  toJSON(message: GetChatRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<GetChatRequest>): GetChatRequest {
    return GetChatRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetChatRequest>): GetChatRequest {
    const message = createBaseGetChatRequest();
    message.chatGuid = object.chatGuid ?? "";
    return message;
  },
};

function createBaseGetChatResponse(): GetChatResponse {
  return { chat: undefined };
}

export const GetChatResponse: MessageFns<GetChatResponse> = {
  encode(message: GetChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chat !== undefined) {
      Chat.encode(message.chat, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chat = Chat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetChatResponse {
    return { chat: isSet(object.chat) ? Chat.fromJSON(object.chat) : undefined };
  },

  toJSON(message: GetChatResponse): unknown {
    const obj: any = {};
    if (message.chat !== undefined) {
      obj.chat = Chat.toJSON(message.chat);
    }
    return obj;
  },

  create(base?: DeepPartial<GetChatResponse>): GetChatResponse {
    return GetChatResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetChatResponse>): GetChatResponse {
    const message = createBaseGetChatResponse();
    message.chat = (object.chat !== undefined && object.chat !== null) ? Chat.fromPartial(object.chat) : undefined;
    return message;
  },
};

function createBaseGetChatCountRequest(): GetChatCountRequest {
  return { includeArchived: false };
}

export const GetChatCountRequest: MessageFns<GetChatCountRequest> = {
  encode(message: GetChatCountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.includeArchived !== false) {
      writer.uint32(8).bool(message.includeArchived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChatCountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChatCountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.includeArchived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetChatCountRequest {
    return {
      includeArchived: isSet(object.includeArchived)
        ? globalThis.Boolean(object.includeArchived)
        : isSet(object.include_archived)
        ? globalThis.Boolean(object.include_archived)
        : false,
    };
  },

  toJSON(message: GetChatCountRequest): unknown {
    const obj: any = {};
    if (message.includeArchived !== false) {
      obj.includeArchived = message.includeArchived;
    }
    return obj;
  },

  create(base?: DeepPartial<GetChatCountRequest>): GetChatCountRequest {
    return GetChatCountRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetChatCountRequest>): GetChatCountRequest {
    const message = createBaseGetChatCountRequest();
    message.includeArchived = object.includeArchived ?? false;
    return message;
  },
};

function createBaseGetChatCountResponse(): GetChatCountResponse {
  return { count: 0 };
}

export const GetChatCountResponse: MessageFns<GetChatCountResponse> = {
  encode(message: GetChatCountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.count !== 0) {
      writer.uint32(8).int64(message.count);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetChatCountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetChatCountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.count = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetChatCountResponse {
    return { count: isSet(object.count) ? globalThis.Number(object.count) : 0 };
  },

  toJSON(message: GetChatCountResponse): unknown {
    const obj: any = {};
    if (message.count !== 0) {
      obj.count = Math.round(message.count);
    }
    return obj;
  },

  create(base?: DeepPartial<GetChatCountResponse>): GetChatCountResponse {
    return GetChatCountResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetChatCountResponse>): GetChatCountResponse {
    const message = createBaseGetChatCountResponse();
    message.count = object.count ?? 0;
    return message;
  },
};

function createBaseHasBackgroundRequest(): HasBackgroundRequest {
  return { chatGuid: "" };
}

export const HasBackgroundRequest: MessageFns<HasBackgroundRequest> = {
  encode(message: HasBackgroundRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== "") {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HasBackgroundRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHasBackgroundRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HasBackgroundRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : "",
    };
  },

  toJSON(message: HasBackgroundRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== "") {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<HasBackgroundRequest>): HasBackgroundRequest {
    return HasBackgroundRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HasBackgroundRequest>): HasBackgroundRequest {
    const message = createBaseHasBackgroundRequest();
    message.chatGuid = object.chatGuid ?? "";
    return message;
  },
};

function createBaseHasBackgroundResponse(): HasBackgroundResponse {
  return { backgroundPresent: false };
}

export const HasBackgroundResponse: MessageFns<HasBackgroundResponse> = {
  encode(message: HasBackgroundResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.backgroundPresent !== false) {
      writer.uint32(8).bool(message.backgroundPresent);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): HasBackgroundResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHasBackgroundResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.backgroundPresent = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): HasBackgroundResponse {
    return {
      backgroundPresent: isSet(object.backgroundPresent)
        ? globalThis.Boolean(object.backgroundPresent)
        : isSet(object.background_present)
        ? globalThis.Boolean(object.background_present)
        : false,
    };
  },

  toJSON(message: HasBackgroundResponse): unknown {
    const obj: any = {};
    if (message.backgroundPresent !== false) {
      obj.backgroundPresent = message.backgroundPresent;
    }
    return obj;
  },

  create(base?: DeepPartial<HasBackgroundResponse>): HasBackgroundResponse {
    return HasBackgroundResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<HasBackgroundResponse>): HasBackgroundResponse {
    const message = createBaseHasBackgroundResponse();
    message.backgroundPresent = object.backgroundPresent ?? false;
    return message;
  },
};

function createBaseSubscribeChatEventsRequest(): SubscribeChatEventsRequest {
  return { chatGuid: undefined };
}

export const SubscribeChatEventsRequest: MessageFns<SubscribeChatEventsRequest> = {
  encode(message: SubscribeChatEventsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.chatGuid !== undefined) {
      writer.uint32(10).string(message.chatGuid);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeChatEventsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeChatEventsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.chatGuid = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeChatEventsRequest {
    return {
      chatGuid: isSet(object.chatGuid)
        ? globalThis.String(object.chatGuid)
        : isSet(object.chat_guid)
        ? globalThis.String(object.chat_guid)
        : undefined,
    };
  },

  toJSON(message: SubscribeChatEventsRequest): unknown {
    const obj: any = {};
    if (message.chatGuid !== undefined) {
      obj.chatGuid = message.chatGuid;
    }
    return obj;
  },

  create(base?: DeepPartial<SubscribeChatEventsRequest>): SubscribeChatEventsRequest {
    return SubscribeChatEventsRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscribeChatEventsRequest>): SubscribeChatEventsRequest {
    const message = createBaseSubscribeChatEventsRequest();
    message.chatGuid = object.chatGuid ?? undefined;
    return message;
  },
};

function createBaseSubscribeChatEventsResponse(): SubscribeChatEventsResponse {
  return { sequence: undefined, chatChanged: undefined, heartbeat: undefined };
}

export const SubscribeChatEventsResponse: MessageFns<SubscribeChatEventsResponse> = {
  encode(message: SubscribeChatEventsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sequence !== undefined) {
      writer.uint32(8).uint64(message.sequence);
    }
    if (message.chatChanged !== undefined) {
      ChatChangeEvent.encode(message.chatChanged, writer.uint32(82).fork()).join();
    }
    if (message.heartbeat !== undefined) {
      Heartbeat.encode(message.heartbeat, writer.uint32(794).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SubscribeChatEventsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscribeChatEventsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.sequence = longToNumber(reader.uint64());
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.chatChanged = ChatChangeEvent.decode(reader, reader.uint32());
          continue;
        }
        case 99: {
          if (tag !== 794) {
            break;
          }

          message.heartbeat = Heartbeat.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscribeChatEventsResponse {
    return {
      sequence: isSet(object.sequence) ? globalThis.Number(object.sequence) : undefined,
      chatChanged: isSet(object.chatChanged)
        ? ChatChangeEvent.fromJSON(object.chatChanged)
        : isSet(object.chat_changed)
        ? ChatChangeEvent.fromJSON(object.chat_changed)
        : undefined,
      heartbeat: isSet(object.heartbeat) ? Heartbeat.fromJSON(object.heartbeat) : undefined,
    };
  },

  toJSON(message: SubscribeChatEventsResponse): unknown {
    const obj: any = {};
    if (message.sequence !== undefined) {
      obj.sequence = Math.round(message.sequence);
    }
    if (message.chatChanged !== undefined) {
      obj.chatChanged = ChatChangeEvent.toJSON(message.chatChanged);
    }
    if (message.heartbeat !== undefined) {
      obj.heartbeat = Heartbeat.toJSON(message.heartbeat);
    }
    return obj;
  },

  create(base?: DeepPartial<SubscribeChatEventsResponse>): SubscribeChatEventsResponse {
    return SubscribeChatEventsResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscribeChatEventsResponse>): SubscribeChatEventsResponse {
    const message = createBaseSubscribeChatEventsResponse();
    message.sequence = object.sequence ?? undefined;
    message.chatChanged = (object.chatChanged !== undefined && object.chatChanged !== null)
      ? ChatChangeEvent.fromPartial(object.chatChanged)
      : undefined;
    message.heartbeat = (object.heartbeat !== undefined && object.heartbeat !== null)
      ? Heartbeat.fromPartial(object.heartbeat)
      : undefined;
    return message;
  },
};

/** Chat-level reads, mutations, and event streams. */
export type ChatServiceDefinition = typeof ChatServiceDefinition;
export const ChatServiceDefinition = {
  name: "ChatService",
  fullName: "photon.imessage.v1.ChatService",
  methods: {
    /** Writes */
    createChat: {
      name: "CreateChat",
      requestType: CreateChatRequest as typeof CreateChatRequest,
      requestStream: false,
      responseType: CreateChatResponse as typeof CreateChatResponse,
      responseStream: false,
      options: {},
    },
    markChatRead: {
      name: "MarkChatRead",
      requestType: MarkChatReadRequest as typeof MarkChatReadRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    setBackground: {
      name: "SetBackground",
      requestType: SetBackgroundRequest as typeof SetBackgroundRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    removeBackground: {
      name: "RemoveBackground",
      requestType: RemoveBackgroundRequest as typeof RemoveBackgroundRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    /**
     * Pushes the local user's name-and-photo card into the target chat so
     * the recipient sees it in their contact suggestions. No observable
     * local state change.
     */
    shareContactInfo: {
      name: "ShareContactInfo",
      requestType: ShareContactInfoRequest as typeof ShareContactInfoRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    /** Transient typing-indicator write. No persisted state. */
    setTyping: {
      name: "SetTyping",
      requestType: SetTypingRequest as typeof SetTypingRequest,
      requestStream: false,
      responseType: Empty as typeof Empty,
      responseStream: false,
      options: {},
    },
    /** Reads */
    getChat: {
      name: "GetChat",
      requestType: GetChatRequest as typeof GetChatRequest,
      requestStream: false,
      responseType: GetChatResponse as typeof GetChatResponse,
      responseStream: false,
      options: {},
    },
    getChatCount: {
      name: "GetChatCount",
      requestType: GetChatCountRequest as typeof GetChatCountRequest,
      requestStream: false,
      responseType: GetChatCountResponse as typeof GetChatCountResponse,
      responseStream: false,
      options: {},
    },
    hasBackground: {
      name: "HasBackground",
      requestType: HasBackgroundRequest as typeof HasBackgroundRequest,
      requestStream: false,
      responseType: HasBackgroundResponse as typeof HasBackgroundResponse,
      responseStream: false,
      options: {},
    },
    subscribeChatEvents: {
      name: "SubscribeChatEvents",
      requestType: SubscribeChatEventsRequest as typeof SubscribeChatEventsRequest,
      requestStream: false,
      responseType: SubscribeChatEventsResponse as typeof SubscribeChatEventsResponse,
      responseStream: true,
      options: {},
    },
  },
} as const;

export interface ChatServiceImplementation<CallContextExt = {}> {
  /** Writes */
  createChat(
    request: CreateChatRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<CreateChatResponse>>;
  markChatRead(request: MarkChatReadRequest, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
  setBackground(request: SetBackgroundRequest, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
  removeBackground(
    request: RemoveBackgroundRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<Empty>>;
  /**
   * Pushes the local user's name-and-photo card into the target chat so
   * the recipient sees it in their contact suggestions. No observable
   * local state change.
   */
  shareContactInfo(
    request: ShareContactInfoRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<Empty>>;
  /** Transient typing-indicator write. No persisted state. */
  setTyping(request: SetTypingRequest, context: CallContext & CallContextExt): Promise<DeepPartial<Empty>>;
  /** Reads */
  getChat(request: GetChatRequest, context: CallContext & CallContextExt): Promise<DeepPartial<GetChatResponse>>;
  getChatCount(
    request: GetChatCountRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<GetChatCountResponse>>;
  hasBackground(
    request: HasBackgroundRequest,
    context: CallContext & CallContextExt,
  ): Promise<DeepPartial<HasBackgroundResponse>>;
  subscribeChatEvents(
    request: SubscribeChatEventsRequest,
    context: CallContext & CallContextExt,
  ): ServerStreamingMethodResult<DeepPartial<SubscribeChatEventsResponse>>;
}

export interface ChatServiceClient<CallOptionsExt = {}> {
  /** Writes */
  createChat(
    request: DeepPartial<CreateChatRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<CreateChatResponse>;
  markChatRead(request: DeepPartial<MarkChatReadRequest>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
  setBackground(request: DeepPartial<SetBackgroundRequest>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
  removeBackground(
    request: DeepPartial<RemoveBackgroundRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<Empty>;
  /**
   * Pushes the local user's name-and-photo card into the target chat so
   * the recipient sees it in their contact suggestions. No observable
   * local state change.
   */
  shareContactInfo(
    request: DeepPartial<ShareContactInfoRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<Empty>;
  /** Transient typing-indicator write. No persisted state. */
  setTyping(request: DeepPartial<SetTypingRequest>, options?: CallOptions & CallOptionsExt): Promise<Empty>;
  /** Reads */
  getChat(request: DeepPartial<GetChatRequest>, options?: CallOptions & CallOptionsExt): Promise<GetChatResponse>;
  getChatCount(
    request: DeepPartial<GetChatCountRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<GetChatCountResponse>;
  hasBackground(
    request: DeepPartial<HasBackgroundRequest>,
    options?: CallOptions & CallOptionsExt,
  ): Promise<HasBackgroundResponse>;
  subscribeChatEvents(
    request: DeepPartial<SubscribeChatEventsRequest>,
    options?: CallOptions & CallOptionsExt,
  ): AsyncIterable<SubscribeChatEventsResponse>;
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from((globalThis as any).Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return (globalThis as any).Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export type ServerStreamingMethodResult<Response> = { [Symbol.asyncIterator](): AsyncIterator<Response, void> };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
